import { Snackbar } from '@mui/material';
import { cloneElement, forwardRef, useCallback, useEffect, useRef } from 'react';
import TavernAlert from './TavernAlert';

export const mobileToastBottom = (stackIndex = 0) =>
  `calc(var(--tavern-mobile-nav-reserved-space, calc(3.75rem + max(0.875rem, env(safe-area-inset-bottom, 0px)))) + 1rem + (${stackIndex} * 4.75rem))`;

export const desktopToastBottom = (stackIndex = 0) =>
  `calc(24px + (${stackIndex} * 4.75rem))`;

const InstantTransition = forwardRef(function InstantTransition(
  { children, in: open, onEnter, onEntered, onExit, onExited },
  ref
) {
  const nodeRef = useRef(null);
  const handleRef = useCallback(
    (node) => {
      nodeRef.current = node;

      if (typeof ref === 'function') {
        ref(node);
      } else if (ref) {
        ref.current = node;
      }
    },
    [ref]
  );

  useEffect(() => {
    const node = nodeRef.current;

    if (open) {
      onEnter?.(node, false);
      onEntered?.(node, false);
      return;
    }

    onExit?.(node);
    onExited?.(node);
  }, [onEnter, onEntered, onExit, onExited, open]);

  return open ? cloneElement(children, { ref: handleRef }) : null;
});

const TavernSnackbar = ({
  action,
  open,
  message,
  severity = 'success',
  onClose,
  autoHideDuration = 3200,
  stackIndex = 0,
}) => (
  <Snackbar
    open={open}
    autoHideDuration={autoHideDuration}
    disableWindowBlurListener
    onClose={onClose}
    anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
    TransitionComponent={InstantTransition}
    sx={{
      bottom: {
        xs: mobileToastBottom(stackIndex),
        sm: desktopToastBottom(stackIndex),
      },
      px: { xs: 2, sm: 0 },
    }}
  >
    <TavernAlert
      elevation={6}
      action={action}
      variant="filled"
      severity={severity}
      onClose={onClose}
      sx={{
        width: '100%',
        maxWidth: 520,
        boxShadow: '0 18px 42px -24px rgba(45, 26, 11, 0.9)',
        fontWeight: 800,
      }}
    >
      {message}
    </TavernAlert>
  </Snackbar>
);

export default TavernSnackbar;
